<template >
    <div class="col-lg-3 col-xxl-2 m-0 p-0  fixed-top">
        <span class="me-auto d-lg-none expand-menu fixed-top" @click="expandMenu($event)"></span>

        <div class="d-none d-lg-block" id="menu-expandido">
            <div class="d-flex flex-column flex-shrink-0 p-2 text-white vh-100" style="width: 280px;background-color: #222428;">
                <h6 class="d-flex align-items-center mb-3 mb-md-0 me-md-auto">
                    <h1 class="text-white text-center mb-2"> <img src="@/assets/img/logo-white.png" :alt="datas.enterprise.name" class="img-fluid logo-empred" style="pointer-events: none;"></h1><span class="recolhe-menu d-lg-none" @click="recolheMenu"></span>
                </h6>
                <hr>
                <div class="accordion mb-auto" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                            <img src="@/assets/img/obra.png" width="32" style="margin-right: 10px;"> All the dates
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" style="max-height:65vh; overflow: auto; padding-bottom:60px;" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                        <div class="accordion-body">

                            <template v-for="(data, index) in dataTitles" :key="data.date">
                                
                                <router-link :to="{ name: 'DataFilter', params: { data: data.date } }" @click="recolheMenu" class="nav-link text-white effect-up position-relative router-link">
                                    <img src="@/assets/img/calendario.png" width="32"> {{ data.title.split('/')[0] }} / {{ data.title.split('/')[1] }}
                                    <img v-if="authenticated" src="@/assets/img/remover.png" title="Remover" class="data-remove effect-up" width="24" @click.prevent="removeData(data.date, index)">
                                </router-link>
                                    
                            </template>
                            
                        </div>
                        
                    </div>
                    </div>
                </div>
                <hr>
                
                <div class="dropdown" v-if="authenticated">
                    <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                        <img src="@/assets/img/user.png" alt="" width="32" height="32" class="rounded-circle me-2">
                        <strong>Hi, {{ user?.name }}</strong> 
                    </a>
                    <ul class="dropdown-menu dropdown-menu-dark text-small shadow" id="dropdown-menu" aria-labelledby="dropdownUser1">
                        <li><hr class="dropdown-divider"><span class="dropdown-item cursor-pointer" @click="logout">Logout</span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Cookies from "js-cookie";
export default {
    name: 'Menu',
    methods:{
        ...mapActions(["setUser", "setAuthenticated"]),
        expandMenu(e){
            e.target.classList.add('d-none');
            document.getElementById('menu-expandido').classList.remove('d-none');
        },
        recolheMenu(){
            document.querySelector('.expand-menu').classList.remove('d-none');
            document.getElementById('menu-expandido').classList.add('d-none');
        },
        logout(){
            var token = Cookies.get('_mysapp_token');
            fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_LOGOUT}`,{
                method:'GET',
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                },
            })
            .then((response) => response.json())
            .then(() => {  
                Cookies.remove('_mysapp_token')
                this.setAuthenticated(false);
                this.setUser(null);
                document.location.reload();
            })
            .catch((err) => console.error(err));
        },
        removeData(dataIn, index){
            if(confirm(`Você está tem certeza que deseja remover os dados de ${this.dataTitles[index].title}?`)){

                
                var token = Cookies.get('_mysapp_token');
                var constructionIndex = this.datas.enterprise.constructionscolumn.findIndex(c => c.date === dataIn);
                var constructionId = this.datas.enterprise.constructionscolumn[constructionIndex].id
            
                fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_DELETE.replace('{id_enterprise}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{id}', constructionId)}`, {
                    method:'POST',
                    headers:{
                        'Authorization' : 'Bearer ' + token
                    } 
                })
                .then((response) => response.json())
                .then((data) => {
                    if(data.delete == 'ok'){
                        
                        this.dataTitles.splice(index, 1);
                        if(this.dataTitles.length){
                            var lastDate = this.dataTitles[0].date;
                        }else{
                             lastDate = '0000-00-00';
                        }
                        this.datas.enterprise.constructionscolumn.splice(index, 1);

                        if(this.$route.params.data == dataIn){
                            this.$router.push(`/${lastDate}`);
                        }
                    }else{
                        alert('Data update was not possible. Please try again later.');
                        window.location.reload();
                    }
                    
                }).catch((err) => console.error(err));
            }
                
        },

    },
    computed: {
        ...mapGetters(["datas", "dataTitles", "authenticated", "user"]),
    }
}
</script>
<style scoped>
#menu-expandido .dropdown-menu-dark {
    color: #586480;
    background-color: #e6ebf5;
    border-color: #dee2e6;
}
#menu-expandido .dropdown-menu-dark .dropdown-item {
    color: #586480;
}
#menu-expandido .dropdown-item:focus{
    background-color: #e6ebf5 !important;
}
.data-remove{
    position: absolute;
    top: -3px;
    right: -3px;
    display: none;
}
.router-link:hover .data-remove{
display: block;
}

#panelsStayOpen-collapseOne::-webkit-scrollbar {
  width: 10px;
}

/* Track */
#panelsStayOpen-collapseOne::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
#panelsStayOpen-collapseOne::-webkit-scrollbar-thumb {
  background: #6f737d;
}

/* Handle on hover */
#panelsStayOpen-collapseOne::-webkit-scrollbar-thumb:hover {
  background: #5b5e65;
}
</style>